import { toast } from "react-toastify";

interface IPaymentCodContainerV2Props {
  value: string;
}

export const PaymentCodContainerV2 = ({
  value,
}: IPaymentCodContainerV2Props) => {
  async function copyToClipboard() {
    await navigator.clipboard.writeText(value);
    toast.info("Codigo copiado!");
  }

  return (
    <div className="flex h-11 w-full max-w-[372px] items-center justify-between gap-2.5 rounded-[2px] bg-[#e8e8e8] px-4">
      <span className="truncate font-['Mulish'] text-sm text-[#20332f]">
        {value}
      </span>
      <button type="button" onClick={copyToClipboard}>
        <img
          src="/assets/svgs/icon-copy-payment-code.svg"
          alt="copiar código"
          className="h-6 w-6 shrink-0"
        />
      </button>
    </div>
  );
};
